import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

export default () => {
  return [
    {
      path: 'checkout',
      name: ROUTES.CHECKOUT_INSURANCE.SESSION,
      component: () =>
        dynamicImport(
          import(
            '@insurance/modules/layout/pages/InsurancePageErrorBoundaryWrapper.vue'
          ),
        ),
      children: [
        {
          path: 'insurance/:sessionId',
          name: ROUTES.CHECKOUT_INSURANCE.PAYMENT,
          component: () =>
            dynamicImport(
              import('@insurance/modules/payment/pages/PaymentPage.vue'),
            ),
          meta: {
            auth: {
              required: true,
            },
          },
        },
        {
          path: 'insurance/billing/:sessionId',
          name: ROUTES.CHECKOUT_INSURANCE.BILLING,
          component: () =>
            dynamicImport(
              import('@insurance/modules/billing/pages/BillingAddressPage.vue'),
            ),
          meta: {
            auth: {
              required: true,
            },
          },
        },
      ],
    },
  ]
}
